import { render } from "./HeaderLogin.vue?vue&type=template&id=473f1dfe&scoped=true"
import script from "./HeaderLogin.vue?vue&type=script&lang=js"
export * from "./HeaderLogin.vue?vue&type=script&lang=js"

import "./HeaderLogin.vue?vue&type=style&index=0&id=473f1dfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473f1dfe"]])

export default __exports__